// extracted by mini-css-extract-plugin
export default {"sliderContainer":"unjZdub__X","timeSection":"xSCSUYg3d_"};